;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { ShowRowContent } from '@/lib/types/api/show-data';
import { atomWithStorage } from 'jotai/utils';
import createStorage from "@/lib/helpers/createStorage";
import { canAccessStorage } from '@/lib/helpers/is-storage-available';

const storage = createStorage<ShowRowContent[] | null>('localStorage')

let storedRecommendedShows = null

if (canAccessStorage('localStorage')) {
  storedRecommendedShows = JSON.parse(window.localStorage.getItem('recommendedShows')!) as ShowRowContent[]
}

export const recommendedShowsAtom = atomWithStorage<ShowRowContent[] | null>('recommendedShows', storedRecommendedShows, storage);

const genreAtoms: Record<string, ReturnType<typeof atomWithStorage<ShowRowContent[] | null>>> = {};

export function getGenreRecommendedShowsAtom(genre: string) {
  if (!genreAtoms[genre]) {
    const key = `recommendedShows:${genre}`;
    const initial = canAccessStorage('localStorage')
      ? JSON.parse(window.localStorage.getItem(key)!) as ShowRowContent[] | null
      : null;
    genreAtoms[genre] = atomWithStorage<ShowRowContent[] | null>(key, initial, storage);
  }
  return genreAtoms[genre];
}
